import { HTTPClient, propsToDate, propsToDatePaged } from "@abaco/web-common/src/HTTP";
import { dbGIStoStandardPage, PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import { Shortcut, ShortcutRaw, toShortcut } from "../models/Shortcut";

export default class ShortcutsApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getShortcuts(): Promise<Shortcut[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/user_registry/hierarchy_shortcuts`, {
            params: {
                sort: "description",
            }
        });
        const shortcuts: Shortcut[] = [];
        res.data.forEach((e: ShortcutRaw) => {
            if(e.enabled !== null && e.items.length === 0){
                shortcuts.push(toShortcut(e, null));
            }
            e.items.forEach((e1: ShortcutRaw) => {
                shortcuts.push(toShortcut(e1, e.id));
            });
        });
        shortcuts.sort(function (a: Shortcut, b: Shortcut) {
            return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
        });
        return shortcuts;
    }

    public async removeShortcut(shortcutId: string): Promise<Shortcut[]> {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/user_registry/shortcuts/${shortcutId}`);
        return res.data;
    }

    public async addShortcut(shortcutId: string): Promise<Shortcut[]> {
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/user_registry/shortcuts`, {
            id: shortcutId
        });
        return res.data;
    }


}
